// localStorage key for the Technical Support banner's UI preference ({ collapsed, position }).
// Not session data: clearCookies() keeps it through logout so it survives re-login (CESMB-8399).
export const TSM_BANNER_STORAGE_KEY = 'tsmBannerState';
